var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.situacoes[_vm.situacao])?_c('CBadge',{attrs:{"color":_vm.situacoes[_vm.situacao].color,"shape":"pill"}},[_vm._v(" "+_vm._s(_vm.situacoes[_vm.situacao].label)+" ")]):_c('CBadge',{attrs:{"color":"secondary","shape":"pill"}},[_vm._v(" "+_vm._s(_vm.situacao)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }